// src/redux/chatSlice.js
import { createSlice } from "@reduxjs/toolkit";

// Initial state
const initialState = {
  supportMessages: [],
  supportLoading: false,
  supportError: null,
  supportTypingUsers: {},
  supportConversationId: null,
};

// Redux slice for chat management
const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    // Load Support Chat History
    LoadSupportChatHistoryRequest: (state) => {
      state.supportLoading = true;
      state.supportError = null;
    },
    LoadSupportChatHistorySuccess: (state, action) => {
      state.supportLoading = false;
      state.supportMessages = action.payload;
    },
    LoadSupportChatHistoryFail: (state, action) => {
      state.supportLoading = false;
      state.supportError = action.payload;
    },

    // Load Support Conversation
    LoadSupportConversation: (state, action) => {
      state.supportConversationId = action.payload;
      localStorage.setItem("supportConversationId", action.payload);
    },

    // Send Support Message
    SendSupportMessageSuccess: (state, action) => {
      state.supportMessages.push(action.payload);
    },

    // Receive Support Message
    ReceiveSupportMessage: (state, action) => {
      state.supportMessages.push(action.payload);
    },

    // Typing Support
    TypingSupport: (state, action) => {
      state.supportTypingUsers["support"] = true;
    },

    // Stop Typing Support
    StopTypingSupport: (state, action) => {
      delete state.supportTypingUsers["support"];
    },

    // Message Read Support
    MessageReadSupport: (state, action) => {
      const { messageId } = action.payload;
      const message = state.supportMessages.find(msg => msg._id === messageId);
      if (message) {
        message.read = true;
      }
    },

    // Clear Chat (if needed)
    ClearChat: (state) => {
      state.supportMessages = [];
      state.supportTypingUsers = {};
      state.supportError = null;
      state.supportLoading = false;
      state.supportConversationId = null;
    },
  },
});

// Export actions
export const {
  LoadSupportChatHistoryRequest,
  LoadSupportChatHistorySuccess,
  LoadSupportChatHistoryFail,
  SendSupportMessageSuccess,
  ReceiveSupportMessage,
  TypingSupport,
  StopTypingSupport,
  MessageReadSupport,
  LoadSupportConversation,
  ClearChat,
} = chatSlice.actions;

// Export reducer
export default chatSlice.reducer;
